module.exports = __webpack_public_path__ + "img/cooperation7.dec42c0d.png";